/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isPrimaryCollapsed: false,
  isSecondaryCollapsed: false,
};

const sidebarSlice = createSlice({
  name: 'sidebar',
  initialState,
  reducers: {
    togglePrimarySidebar: (state) => {
      state.isPrimaryCollapsed = !state.isPrimaryCollapsed;
    },
    toggleSecondarySidebar: (state) => {
      state.isSecondaryCollapsed = !state.isSecondaryCollapsed;
    },
  },
});

export const { togglePrimarySidebar, toggleSecondarySidebar } = sidebarSlice.actions;
export default sidebarSlice.reducer;
